<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" scrollable max-width="540px">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Patient Data</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
                <v-progress-linear v-if="waiting" :indeterminate="true"/>
                <v-card-text id="patientDataId">
                    <ValidationObserver ref="observer" v-slot="{ invalid }">
                        <v-form>
                            <PatientDataBioInfo/>
                            <PatientDataContactInfo :requireFields="false" />
                        </v-form>
                    </ValidationObserver>
                </v-card-text>
            </v-card>
        </v-dialog>
        <ConfirmationDialog v-if="confirmLoseChanges" :params="confirmLoseChangesParams" @confirmation-dialog-response="confirmLoseChangesHandler"></ConfirmationDialog>
    </div>
</template>

<script>
    const clonedeep = require('lodash.clonedeep');
    import { mapState, mapActions, mapMutations } from 'vuex';
    import { ValidationObserver } from 'vee-validate';
    import PatientDataBioInfo from '@/components/patient-data-bio-info';
    import PatientDataContactInfo from '@/components/patient-data-contact-info';
    import ConfirmationDialog from '@/components/confirmation-dialog';

    export default
    {
        name: 'patient-data-dialog',
        components:
        {
            ValidationObserver,
            PatientDataBioInfo,
            PatientDataContactInfo,
            ConfirmationDialog
        },
        data: function ()
        {
            return {
                dialogLocal: false,
                oldPatientData: {},
                oldMrn: null,
                confirmLoseChanges: false,
                confirmLoseChangesParams:
                {
                    title: 'About to Lose Changes',
                    text: 'You have unsaved patient updates. Lose changes?',
                    positiveResponse: 'Yes',
                    negativeResponse: 'No'
                },
                shouldRefreshTests: null
            }
        },
        props:
        {
            dialog: Boolean(false),
            newPatient: Boolean(false)
        },
        computed:
        {
            ...mapState('tests',
            {
                patientDataToMutate: state => state.patientDataToMutate
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        watch:
        {
            dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.HIDE_SNACKBAR();
                    this.$emit('dialog-close', this.shouldRefreshTests);
                    this.$refs.observer.reset()
                }
                else // Else the dialog is being opened
                {
                    this.$logEvent(this.$firebaseAnalytics, 'screen_view',
                    {
                        app_name: 'Web Portal',
                        screen_name: `Reflex Web Portal - ${this.$options.name}`,
                        app_version: process.env.VUE_APP_VERSION
                    });
                    this.dialogLocal = val;
                    // Track the original data
                    this.oldMrn = this.patientDataToMutate.mrn;
                    this.oldPatientData = clonedeep(this.patientDataToMutate)
                }
            },
            dialog(val)
            {
                this.dialogLocal = val
            }
        },
        methods:
        {
            ...mapActions('tests', ['SAVE_PATIENT_DATA']),
            ...mapMutations('tests', ['UPDATE_MUTATED_PATIENT_DATA']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_WARN_DELAY', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            closeDialog()
            {
                if (JSON.stringify(this.oldPatientData) !== JSON.stringify(this.patientDataToMutate))
                {
                    this.confirmLoseChanges = true;
                    return
                }
                this.postClose(false)
            },
            postClose(shouldRefreshTests)
            {
                this.shouldRefreshTests = shouldRefreshTests
                document.getElementById('patientDataId').scrollTop = 0;
                this.dialogLocal = false
            },
            confirmLoseChangesHandler(payload)
            {
                this.confirmLoseChanges = false;
                // If the changes should be lost
                if (payload.response)
                {
                    // The user is losing their changes, so put back the original values
                    this.UPDATE_MUTATED_PATIENT_DATA(this.oldPatientData)
                    this.postClose(false)
                }
            },
            async save()
            {
                // If there is something to save and the validation has passed
                if (await this.$refs.observer.validate() && JSON.stringify(this.oldPatientData) !== JSON.stringify(this.patientDataToMutate))
                {
                    try
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        await this.SAVE_PATIENT_DATA({data: this.patientDataToMutate, oldMrn: this.oldMrn});
                        this.postClose(true)
                    }
                    catch (error)
                    {
                        // If the request could not proceed
                        if (1 === error.code)
                        {
                            this.SHOW_SNACKBAR_WARN_DELAY({message: error.message, delay: 10000})
                        }
                        else
                        {
                            this.SHOW_SNACKBAR_ERROR(error.message)
                        }
                    }
                    this.WAITING(false)
                }
                // If there is nothing to save
                else if (JSON.stringify(this.oldPatientData) === JSON.stringify(this.patientDataToMutate))
                {
                    this.SHOW_SNACKBAR_WARN_DELAY({message: "There is nothing to save because no changes have been made.", delay: 10000})
                }
            }
        }
    };
</script>

<style scoped>
</style>